/**
 * Per-service Kai chat configuration — same UI, service-specific API + copy.
 */

export const KAI_CHAT_CONFIGS = {
  denial_management: {
    serviceKey: 'denial_management',
    serviceName: 'Denial Management',
    modelLabel: 'AgenticPractice Denial Management 1.0',
    backendPort: 8154,
    frontendPort: 3154,
    shellApiPrefix: '/rcm-api/denial',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for denial management. I can help you understand denials, process appeals, identify patterns, search payer policies, and get insights about your denial management process. How can I help you today?",
    analyticsPath: '/analytics?tab=kai-intelligence',
    contextKeys: ['claim_id', 'claimId', 'denial_id', 'denialId'],
  },
  prior_authorization: {
    serviceKey: 'prior_authorization',
    serviceName: 'Prior Authorization',
    modelLabel: 'AgenticPractice Prior Authorization 1.0',
    backendPort: 8151,
    frontendPort: 3151,
    shellApiPrefix: '/rcm-api/prior-authorization',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for prior authorization. I can help you understand PA requests, look up CPT/ICD codes, handle denials and appeals, check authorization status, search payer policies, and get insights about your prior authorization process. Try: \"What is CPT 99213?\"",
    analyticsPath: '/analytics?tab=kai-intelligence',
    contextKeys: ['request_id', 'requestId', 'patient_id', 'patientId'],
  },
  insurance_verification: {
    serviceKey: 'insurance_verification',
    serviceName: 'Insurance Verification',
    modelLabel: 'AgenticPractice Insurance Verification 1.0',
    backendPort: 8150,
    frontendPort: 3150,
    shellApiPrefix: '/rcm-api/insurance-verification',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for insurance verification. I can help you check eligibility, understand benefits, search payer policies, and guide verification workflows. How can I help you today?",
    analyticsPath: '/analytics?tab=kai-intelligence',
    contextKeys: ['patient_id', 'patientId', 'member_id', 'memberId'],
  },
  claims_processing: {
    serviceKey: 'claims_processing',
    serviceName: 'Claims Processing',
    modelLabel: 'AgenticPractice Claims Processing 1.0',
    backendPort: 8153,
    frontendPort: 3153,
    shellApiPrefix: '/rcm-api/claims-processing',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for claims processing. I can help you validate claims, understand submission requirements, search payer policies, and troubleshoot claim issues. How can I help you today?",
    analyticsPath: '/analytics?tab=kai-intelligence',
    contextKeys: ['claim_id', 'claimId'],
  },
  charge_capture: {
    serviceKey: 'charge_capture',
    serviceName: 'Charge Capture',
    modelLabel: 'AgenticPractice Charge Capture 1.0',
    backendPort: 8152,
    frontendPort: 3152,
    shellApiPrefix: '/rcm-api/charge-capture',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for charge capture. I can help you review charges, look up CPT/ICD/HCPCS codes, understand coding guidelines, search payer policies, and optimize charge workflows. Try: \"What is CPT 99213?\" or \"search ICD diabetes\".",
    analyticsPath: '/analytics',
    contextKeys: ['encounter_id', 'encounterId', 'claim_id', 'claimId'],
  },
  ar_posting: {
    serviceKey: 'ar_posting',
    serviceName: 'AR Posting',
    modelLabel: 'AgenticPractice AR Posting 1.0',
    backendPort: 8155,
    frontendPort: 3155,
    shellApiPrefix: '/rcm-api/ar-posting',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for AR posting. I can help you with payment posting, adjustments, reconciliation, search payer policies, and analyzing your AR data. How can I help you today?",
    analyticsPath: '/analytics',
    contextKeys: ['payment_id', 'paymentId', 'era_id', 'eraId'],
  },
  remittance_advice: {
    serviceKey: 'remittance_advice',
    serviceName: 'Remittance Advice',
    modelLabel: 'AgenticPractice Remittance Advice 1.0',
    backendPort: 8157,
    frontendPort: 3157,
    shellApiPrefix: '/rcm-api/remittance',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for remittance advice. I can help you understand ERA/EOB payments, denial codes, search payer policies, and reconcile remittances. How can I help you today?",
    analyticsPath: '/analytics',
    contextKeys: ['eob_id', 'eobId', 'era_id', 'eraId'],
  },
  rcm_compliance: {
    serviceKey: 'rcm_compliance',
    serviceName: 'RCM Compliance',
    modelLabel: 'AgenticPractice RCM Compliance 1.0',
    backendPort: 8158,
    frontendPort: 3158,
    shellApiPrefix: '/rcm-api/compliance',
    welcomeMessage:
      "Hello! I'm Kai for RCM Compliance. I provide Information & Education — not coding, legal, or appeal authorization. I can summarize your compliance queue, explain NCCI/MUE and timely filing signals, search guidelines, and guide disposition (ALLOW/WARN/BLOCK). Try: \"Summarize my compliance queue\" or \"What findings exist for claim CLM-123?\" Human attestation is required for HIGH/CRITICAL overrides.",
    analyticsPath: '/kai',
    contextKeys: ['entity_id', 'entityId', 'claim_id', 'claimId'],
  },
  contract_management: {
    serviceKey: 'contract_management',
    serviceName: 'Contract Management',
    modelLabel: 'AgenticPractice Contract Management 1.0',
    backendPort: 8156,
    frontendPort: 3156,
    shellApiPrefix: '/rcm-api/contract-management',
    welcomeMessage:
      "Hello! I'm Kai. I provide Information & Education for contract management. I can help you understand contracts, payers, credentialing, fee schedules, and search payer policies. How can I help you today?",
    analyticsPath: '/analytics',
    contextKeys: ['contract_id', 'contractId', 'payer_id', 'payerId'],
  },
  platform: {
    serviceKey: 'platform',
    serviceName: 'Platform',
    modelLabel: 'AgenticPractice Platform 1.0',
    backendPort: 8154,
    frontendPort: null,
    shellApiPrefix: '/rcm-api/denial',
    welcomeMessage:
      "Hello! I'm Kai, your platform AI assistant. I route your questions to the right specialist — denials, AR posting, claims, prior auth, and more — or help with navigation and support. What would you like help with today?",
    analyticsPath: '/help',
    contextKeys: [],
  },
  kai_support: {
    serviceKey: 'kai_support',
    serviceName: 'Support',
    modelLabel: 'Kai Support 1.0',
    backendPort: 8154,
    frontendPort: null,
    shellApiPrefix: '/rcm-api/denial',
    welcomeMessage:
      "Hello! I'm Kai Support. I can help you navigate the platform, explain workflows, troubleshoot common issues, and point you to the right service or documentation. How can I help you today?",
    analyticsPath: '/help',
    contextKeys: [],
  },
  patient_portal: {
    serviceKey: 'patient_portal',
    serviceName: 'Patient Portal',
    modelLabel: 'Patient Portal Kai 1.0',
    backendPort: 8225,
    frontendPort: 3225,
    shellApiPrefix: '/patient-api',
    welcomeMessage:
      "Hello! I'm Kai. I can help you with appointments, messages, health records, billing questions, and navigating your patient portal. How can I help you today?",
    analyticsPath: '/help',
    contextKeys: [],
  },
};

export function getKaiChatConfig(serviceKey) {
  return KAI_CHAT_CONFIGS[serviceKey] || KAI_CHAT_CONFIGS.denial_management;
}
